// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"29":"81c3aaff","49":"46693b1b","65":"6bd461d8","79":"b349c7d9","101":"dec09f2e","145":"316bd246","242":"c93c9a60","312":"9f4d5ee7","636":"5daf798a","645":"3fe0fec5","714":"2c45f95e","739":"7da1d480","877":"6978f408","948":"36c1aedd"}[chunkId] + ".js";
};